import useIsMobile from "@/hooks/useIsMobile";
import PageLayout from "@/screens/Layout/PageLayout";
import TopicDetail from "@/screens/TopicDetail";

const Index = ({
  topicDetailData = null,
  latestStoryData = null,
  latestVideoData = null,
}) => {
  const isMobileDevice = useIsMobile();
  return (
    <PageLayout
      latestStoryData={latestStoryData}
      latestVideoData={latestVideoData}
      isMobileDevice={isMobileDevice}
    >
      <TopicDetail
        topicDetailData={topicDetailData}
        isMobileDevice={isMobileDevice}
      />
    </PageLayout>
  );
};

export default Index;

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    const { slug } = ctx?.params;
    const { getTopicDetailBySlug } = await import("@/handlers/topic");
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let siteName = process.env.REDIS_KEY_APP_PREFIX;
    let topicDetailRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "searchlist",
        site: siteName,
        type: "all",
        key: slug,
        page: page,
        topicByTitle: slug,
        display: 12,
      },
    });
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    let [topicDetailData, { latestStoryData, latestVideoData }] = await Promise.all(
      [
        fetchRedisWrapper(topicDetailRedisKey, () =>
          getTopicDetailBySlug({ topicSlug: slug, page, display: 12 })
        ),
        fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      ]
    );

    if (!topicDetailData || Object.keys(topicDetailData).length === 0) {
      // console.log("not found");
      return {
        // notFound: true,
        redirect: {
          destination: "/search/" + slug,
          statusCode: 301,
        },
      };
    }

    let headerCache = topicDetailData?.headerCache;
    setPageTTL(ctx, headerCache?.akamai_ttl);

    return {
      props: {
        topicDetailData,
        latestStoryData,
        latestVideoData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
